module.exports = __webpack_public_path__ + "img/bj-screenshot1.7abf1b40.png";